import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { NotificationManager } from "react-notifications";
import Consent from "../Impact/Consent";
import FormulaDialog from "../Impact/Formula";
import ClinicalHistory from "../Impact/ClinicalHistory";
import PatientInfo from "../Impact/PatientInfo";
import Education from "../Impact/Education";
import RadicacionInsurance from "./RadicacionInsurance";
import InsuranceAuthorization from "./InsuranceAuthorization";
import RadicadoOLF from "./RadicadoOLF";
import Delivery from "./MedicineDelivery";
import Alert from "./Alert";
import Dosage from "./Dosage";
import ClinicalFinding from "./ClinicalFinding";
import MorisKySurvey from "./MorisKySurvey";
import MedicineConsumption from "./MedicineConsumption";
import EducationLevelSurvey from "./EducationLevelSurvey";
import HealingMaterial from "./HealingMaterial";
import CatheterStatus from "./CatheterStatus";
import InfusionPumps from "./InfusionPumps";
import ProductStatus from "./ProductStatus";
import HealthData from "./HealthData";
import Ledaga from "./Ledaga";
import Panhematin from "./Panhematin";
import Sylvant from "./Sylvant";
import VitalNotAvailable from "./VitalNotAvailable";
import AdditionalMedications from "../Impact/AdditionalMedications";
import Qarziba from "./Qarziba";
import CycleVials from "./CycleVial";
import DosageDlg from "../Impact/Dosage";
import PatientStateBox from "components/JaasModule/PatientStateBox";
import IsOnlyTracingBox from "components/JaasModule/IsOnlyTracingBox";
import {
  isOnlyTracing,
  isDirectTracing,
  isJaasModule,
  getBoolSetting,
  isTracingDeliveryBox,
  getUserInfo,
  isPharmacotherapeuticRisk
} from "app/routes/psp/services/userService";
import { loadInfoImpact, setHealthData } from "actions/Impact";
import {
  PrescripStateEnum,
  ProductBehavior,
  FolderType,
  RoleEnum,
  SettingsEnum,
  ShardKeyEnum
} from "constants/Enums";
import { callActionApi, getInfoImpact } from "api/apiList";
import { isRole } from "app/routes/psp/services/userService";
import TracingDelivery from "./TracingDelivery";
import Diagnosis from "./Diagnosis";
import AdverseReaction from "./AdverseReaction";
import ControlExam from "./ControlExam";
import { callApi, getGetHealthData } from "api/apiList";
import PharmacotherapeuticRisk from "./PharmacotherapeuticRisk";

const FirstImpact = ({ menuItemOverride }) => {
  const [deliverHealthData, setDeliverHealthData] = useState(null);
  const dispatch = useDispatch();
  const { selectedPrescription, selectedMenuItem } = useSelector(
    ({ management }) => management
  );
  const effectiveMenuItem =
    menuItemOverride !== undefined && menuItemOverride !== null
      ? menuItemOverride
      : selectedMenuItem;
  const isJaasModuleConfig = isJaasModule();
  const isTracingDeliveryBoxConfig = isTracingDeliveryBox();
  const isNurseProcedure = isRole(RoleEnum.nurse_procedure);

  const loadDeliverHealthData = () => {
    if (!selectedPrescription?.impactId) return;
    callApi(
      () => getGetHealthData(selectedPrescription.impactId),
      (data) => {
        setDeliverHealthData(data.numberDeliveries);
        dispatch(setHealthData(data));
      }
    );
  };

  useEffect(() => {
    if (!selectedPrescription?.impactId) return;

    loadDeliverHealthData();
    callActionApi(
      () => getInfoImpact(selectedPrescription.impactId),
      (data) => {
        dispatch(loadInfoImpact(data));
      },
      (error) => {
        if (typeof error === "string") NotificationManager.error(error);
      } //, (data) => dispatch(setLoader(data))
    );
  }, [selectedPrescription?.impactId]);

  if (!selectedPrescription?.patient) {
    return null;
  }

  const isOnlyTrace =
    isOnlyTracing() === true ||
    selectedPrescription.patient?.isOnlyTracing === true ||
    !selectedPrescription.expeditionDate;
  const isPSPBoxesPhg = getBoolSetting(SettingsEnum.hideBoxes);
  const isOperando = getUserInfo().shardKey === ShardKeyEnum.operando;
  const isDirectTracingConfig = isDirectTracing();
  return (
    <div>
      <div className="row first-impact-box-margins">
        {(effectiveMenuItem === FolderType.tracing ||
          selectedPrescription.stateId === PrescripStateEnum.fristImpact) && (
            <div className="col-xl-4 col-lg-4 col-md-4 col-sm-12">
              <Consent />
            </div>
          )}
        {!isNurseProcedure && (
          <div className="col-xl-4 col-lg-4 col-md-4 col-sm-12">
            <PatientInfo />
          </div>
        )}
        <div className="col-xl-4 col-lg-4 col-md-4 col-sm-12">
          {!(
            isOnlyTracing() === true ||
            selectedPrescription.patient.isOnlyTracing === true
          ) && <FormulaDialog />}
          {(isOnlyTracing() === true ||
            selectedPrescription.patient.isOnlyTracing === true) && (
              <HealthData loadDeliverHealthData={loadDeliverHealthData} />
            )}
        </div>
        <div className="col-xl-4 col-lg-4 col-md-4 col-sm-12">
          <ClinicalHistory />
        </div>

        {selectedPrescription.stateId !== PrescripStateEnum.NewFormulation &&
          effectiveMenuItem === FolderType.inProcess && (
            <div className="col-xl-4 col-lg-4 col-md-4 col-sm-12">
              <Alert />
            </div>
          )}
        {(effectiveMenuItem === FolderType.tracing ||
          selectedPrescription.stateId === PrescripStateEnum.fristImpact) && (
            <React.Fragment>
              <div className="col-xl-4 col-lg-4 col-md-4 col-sm-12">
                <AdditionalMedications />
              </div>
              {isDirectTracing() === true && (
                <div className="col-xl-4 col-lg-4 col-md-4 col-sm-12">
                  <DosageDlg />
                </div>
              )}
              {isTracingDeliveryBoxConfig ? (
                <></>
              ) : (
                <div className="col-xl-4 col-lg-4 col-md-4 col-sm-12">
                  <Education />
                </div>
              )}
              {/* <div className="col-xl-4 col-lg-4 col-md-4 col-sm-12">
              <NursePlan />
            </div> */}
            </React.Fragment>
          )}

        {(selectedPrescription.stateId === PrescripStateEnum.radicacionEPS ||
          selectedPrescription.stateId === PrescripStateEnum.noAuthorized ||
          selectedPrescription.stateId ===
          PrescripStateEnum.radicacionEPSNonEffective ||
          selectedPrescription.stateId ===
          PrescripStateEnum.authorizationWithInconsistencies) &&
          effectiveMenuItem === FolderType.inProcess && (
            <div className="col-xl-4 col-lg-4 col-md-4 col-sm-12">
              <RadicacionInsurance />
            </div>
          )}
        {selectedPrescription.stateId == PrescripStateEnum.authorized &&
          effectiveMenuItem === FolderType.inProcess && (
            <div className="col-xl-4 col-lg-4 col-md-4 col-sm-12">
              <InsuranceAuthorization />
            </div>
          )}
        {(selectedPrescription.stateId === PrescripStateEnum.radicacionOLF ||
          selectedPrescription.stateId ===
          PrescripStateEnum.radicacionOLFNonEffective ||
          selectedPrescription.stateId === PrescripStateEnum.delivered ||
          selectedPrescription.stateId === PrescripStateEnum.deliveryNotMade ||
          selectedPrescription.stateId ===
          PrescripStateEnum.incompleteDelivery) &&
          effectiveMenuItem === FolderType.inProcess && (
            <div className="col-xl-4 col-lg-4 col-md-4 col-sm-12">
              <RadicadoOLF />
            </div>
          )}
        {(selectedPrescription.stateId === PrescripStateEnum.delivered ||
          selectedPrescription.stateId === PrescripStateEnum.deliveryNotMade ||
          selectedPrescription.stateId ===
          PrescripStateEnum.incompleteDelivery) &&
          effectiveMenuItem === FolderType.inProcess && (
            <div className="col-xl-4 col-lg-4 col-md-4 col-sm-12">
              <Delivery />
            </div>
          )}

        {effectiveMenuItem === FolderType.tracing && (
          <>
            {!isOnlyTrace && (
              <div className="col-xl-4 col-lg-4 col-md-4 col-sm-12">
                <Dosage />
              </div>
            )}
            {isJaasModuleConfig && (
              <div className="col-xl-4 col-lg-4 col-md-4 col-sm-12">
                <PatientStateBox />
              </div>
            )}
            {!isTracingDeliveryBoxConfig && (
              <div className="col-xl-4 col-lg-4 col-md-4 col-sm-12">
                <ClinicalFinding />
              </div>
            )}
            {!isOnlyTrace && (
              <div className="col-xl-4 col-lg-4 col-md-4 col-sm-12">
                <MedicineConsumption />
              </div>
            )}
            {/* {isOnlyTrace && (
              <div className="col-xl-4 col-lg-4 col-md-4 col-sm-12">
                <MedicineConsumptionTracing />
              </div>
            )} */}
            <div className="col-xl-4 col-lg-4 col-md-4 col-sm-12">
              <ProductStatus />
            </div>
            {isTracingDeliveryBoxConfig && (
              <div className="col-xl-4 col-lg-4 col-md-4 col-sm-12">
                <TracingDelivery deliverHealthData={deliverHealthData} />
              </div>
            )}
          </>
        )}
        {((!isOnlyTrace &&
          effectiveMenuItem == FolderType.tracing &&
          selectedPrescription.customProductBehaviorId ===
          ProductBehavior.iclusig) ||
          (effectiveMenuItem == FolderType.tracing &&
            selectedPrescription.customProductBehaviorId ===
            ProductBehavior.dacepton)) && (
            <div className="col-xl-4 col-lg-4 col-md-4 col-sm-12">
              <MorisKySurvey />
            </div>
          )}
        {((!isOnlyTrace &&
          effectiveMenuItem === FolderType.tracing &&
          selectedPrescription.customProductBehaviorId ===
          ProductBehavior.remodulin) ||
          (effectiveMenuItem === FolderType.tracing &&
            selectedPrescription.customProductBehaviorId ===
            ProductBehavior.dacepton)) && (
            <React.Fragment>
              {!isPSPBoxesPhg && (
                <div className="col-xl-4 col-lg-4 col-md-4 col-sm-12">
                  <CatheterStatus
                    isRemodulin={
                      selectedPrescription.customProductBehaviorId ===
                      ProductBehavior.remodulin
                    }
                  />
                </div>
              )}
              {!isPSPBoxesPhg && (
                <div className="col-xl-4 col-lg-4 col-md-4 col-sm-12">
                  <InfusionPumps />
                </div>
              )}
              {selectedPrescription.customProductBehaviorId ===
                ProductBehavior.remodulin && (
                  <div className="col-xl-4 col-lg-4 col-md-4 col-sm-12">
                    <EducationLevelSurvey />
                  </div>
                )}
              {!isPSPBoxesPhg && (
                <div className="col-xl-4 col-lg-4 col-md-4 col-sm-12">
                  <HealingMaterial />
                </div>
              )}
            </React.Fragment>
          )}
        {selectedPrescription.productLineId ===
          ProductBehavior.ledaga && (
            <div className="col-xl-4 col-lg-4 col-md-4 col-sm-12">
              <Ledaga/>
            </div>
          )}
        {selectedPrescription.productLineId ===
          ProductBehavior.panhematin && (
            <div className="col-xl-4 col-lg-4 col-md-4 col-sm-12">
              <Panhematin/>
            </div>
          )}
          {selectedPrescription.productLineId ===
          ProductBehavior.sylvant && (
            <div className="col-xl-4 col-lg-4 col-md-4 col-sm-12">
              <Sylvant/>
            </div>
          )}
          {selectedPrescription.productLineId ===
          ProductBehavior.qarziba && (
            <div className="col-xl-4 col-lg-4 col-md-4 col-sm-12">
              <Qarziba/>
            </div>
          )}
          {(selectedPrescription.productLineId === ProductBehavior.qarziba ||
            selectedPrescription.productLineId === ProductBehavior.sylvant) && (
            <div className="col-xl-4 col-lg-4 col-md-4 col-sm-12">
              <CycleVials />
            </div>
          )}
          
        {!isDirectTracingConfig && isJaasModuleConfig && (
          <div className="col-xl-4 col-lg-4 col-md-4 col-sm-12">
            <IsOnlyTracingBox />
          </div>
        )}
        {isOperando && (
          <div className="col-xl-4 col-lg-4 col-md-4 col-sm-12">
            <InfusionPumps />
          </div>
        )}
        {isDirectTracing() === true && (
          <div className="col-xl-4 col-lg-4 col-md-4 col-sm-12">
            <Diagnosis />
          </div>
        )}
        {isDirectTracing() == true && (
          <>
            <div className="col-xl-4 col-lg-4 col-md-4 col-sm-12">
              <AdverseReaction />
            </div>
            <div className="col-xl-4 col-lg-4 col-md-4 col-sm-12">
              <ControlExam />
            </div>
          </>
        )}
        {isPharmacotherapeuticRisk() == true && (
          <div className="col-xl-4 col-lg-4 col-md-4 col-sm-12">
            <PharmacotherapeuticRisk prescription={selectedPrescription} />
          </div>
        )}
      </div>
    </div>
  );
};

export default FirstImpact; 
